import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { CategoriesForm } from './categories-form';

export function Categories(): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  if (data) {
    return <CategoriesForm data={data} />;
  }

  console.error(new Error(`missing web customization data`));
  return null;
}
